import "../css/B2BCapabilities.css";

export default function B2BCapabilities() {
	return (
		<section className="split-section-wrapper container">
			<div className="split-section">
				{/* LEFT IMAGE GRID */}
				<div className="image-grid">
					<div className="img img-1">
						<img
							src="/images/B2BCap/B2Bcapabilities1.png"
							alt="Rug design"
						/>
					</div>
					<div className="img img-2">
						<img
							src="/images/B2BCap/B2Bcapabilities2.png"
							alt="Rug texture"
						/>
					</div>
					<div className="img img-3">
						<img
							src="/images/B2BCap/B2Bcapabilities3.png"
							alt="Kids rug"
						/>
					</div>
					<div className="img img-4">
						<img
							src="/images/B2BCap/B2Bcapabilities4.png"
							alt="Minimal rug"
						/>
					</div>
				</div>

				{/* RIGHT CONTENT */}
				<div className="content-section">
					<span className="section-tag my-3">OUR CAPABILITIES</span>
					<h2>Built for Global B2B Buyers</h2>
					<p className="intro-text">
						We support international brands, retailers, and
						designers with structured manufacturing, quality-driven
						execution, and export-ready operations.
					</p>

					<ul className="feature-list">
						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>OEM & Private Label Manufacturing</h4>
								<p>
									In-house production aligned with your brand
									and specifications.
								</p>
							</div>
						</li>
						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Custom Design & Development</h4>
								<p>
									Design, sampling, and materials managed
									internally.
								</p>
							</div>
						</li>
						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Project & Bulk Order Management</h4>
								<p>
									Structured handling of small to large-volume
									orders with defined timelines and QC
									checkpoints
								</p>
							</div>
						</li>

						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Sampling & Prototyping Support</h4>
								<p>
									Pre-production samples developed and
									approved before bulk manufacturing
								</p>
							</div>
						</li>

						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Export-Ready Logistics</h4>
								<p>
									Global shipping, packaging, and
									documentation handled end-to-end.
								</p>
							</div>
						</li>

						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>End-to-End Export Logistics</h4>
								<p>
									Coordinated global shipping from India to
									your destination
								</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</section>
	);
}
